import React from 'react';
import { HoInvitedBetterWayToBuildContainer } from '../../common';
import InvitedByInsuranceBetterWayMobile from './InvitedByInsuranceBetterWayMobile';
import InvitedByInsuranceBetterWayDesktop from './InvitedByInsuranceBetterWayDesktop';

const BetterWayToBuild: React.FC = () => (
  <HoInvitedBetterWayToBuildContainer numberOfSlides={2}>
    <InvitedByInsuranceBetterWayMobile />
    <InvitedByInsuranceBetterWayDesktop />
  </HoInvitedBetterWayToBuildContainer>
);

export default BetterWayToBuild;
